import { render, staticRenderFns } from "./PersistBaseFretebasEmpresaView.vue?vue&type=template&id=6de8658c&"
import script from "./PersistBaseFretebasEmpresaView.vue?vue&type=script&lang=ts&"
export * from "./PersistBaseFretebasEmpresaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports